
import LayoutThree from "pages/User/LayoutThree/index.page";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.LAYOUTTHREE.path,
      name: "LAYOUTTHREE",
      key: routesMap.LAYOUTTHREE.path,
      // commonRoute: false,
      private: true,
      // withAuth: true,
      // belongsToHeader: true,
      element: <LayoutThree />,
    }
  ];
}
